import React, { useState, useEffect } from "react";
import { Button, Select, notification, Checkbox } from "antd";
import Modal from "components/General/ModalFormComponents/Modal";
import styles from "./style.module.scss";
import Uploader from "./uploder";
import {
  DeleteOutlined,
  PlusOutlined,
  CloseOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AddPhnPopup from "../security/mfa/Representation";
import { apiRequest } from "util/services";

const GDPR_AGREEMENT_TEXT_TR = `Kişisel Verilerin Korunması ve GDPR Kapsamında Telefon Numarası İşleme Sözleşmesi

1. Amaç
Bu metin, Pivony platformuna telefon numaranızı eklerken kişisel verilerinizin nasıl işleneceğine ilişkin bilgilendirme ve onay metnini kapsamaktadır.

2. İşlenen Veri
Girdiğiniz telefon numarası, Pivony tarafından uyarı ve bildirim göndermek amacıyla işlenecektir.

3. Uluslararası Veri Transferi
Telefon numaranız, hizmetin sunulması amacıyla Türkiye sınırları dışındaki sunucularda (AB ülkeleri ve/veya diğer üçüncü ülkeler dahil) saklanabilir ve işlenebilir. Bu işlem; 6698 sayılı KVKK'nın 9. maddesi ve AB Genel Veri Koruma Tüzüğü (GDPR) Madde 46 kapsamındaki uygun güvenceler çerçevesinde gerçekleştirilmektedir.

4. Hukuki Dayanak
• KVKK: Açık rıza (Madde 5/1)
• GDPR: Açık rıza (Madde 6/1-a)

5. Saklama Süresi
Telefon numaranız, hesabınız aktif olduğu sürece saklanır. Hesap silme veya numara kaldırma işlemi ile birlikte veri silinir.

6. Haklarınız
KVKK Madde 11 ve GDPR Madde 15–22 kapsamında; verilerinize erişme, düzeltme, silme, işlemeyi kısıtlama ve itiraz etme haklarına sahipsiniz. Talepleriniz için: privacy@pivony.com

7. Onay
Bu formu onaylayarak, telefon numaranızın yukarıda belirtilen koşullar dahilinde uluslararası olarak işlenmesine açık rıza verdiğinizi kabul etmiş olursunuz.`;

const GDPR_AGREEMENT_TEXT_EN = `Phone Number Data Processing Agreement under GDPR & KVKK

1. Purpose
This text provides information and consent regarding how your personal data will be processed when you add your phone number to the Pivony platform.

2. Data Processed
The phone number you enter will be processed by Pivony for the purpose of sending alerts and notifications.

3. International Data Transfer
Your phone number may be stored and processed on servers outside of Turkey (including EU countries and/or other third countries) for the purpose of providing the service. This is carried out within the framework of appropriate safeguards under Article 9 of Law No. 6698 (KVKK) and Article 46 of the EU General Data Protection Regulation (GDPR).

4. Legal Basis
• KVKK: Explicit consent (Article 5/1)
• GDPR: Explicit consent (Article 6/1-a)

5. Retention Period
Your phone number is retained for as long as your account is active. Upon account deletion or number removal, the data will be deleted.

6. Your Rights
Under Article 11 of KVKK and Articles 15–22 of GDPR, you have the right to access, correct, delete, restrict processing of, and object to your data. Contact: privacy@pivony.com

7. Consent
By confirming this form, you acknowledge that you give explicit consent to the international processing of your phone number under the conditions stated above.`;

const GdprAgreementPopup = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const agreementText = i18n.language === "tr" ? GDPR_AGREEMENT_TEXT_TR : GDPR_AGREEMENT_TEXT_EN;
  return (
    <div className={styles.agreementOverlay} onClick={onClose}>
      <div className={styles.agreementBox} onClick={(e) => e.stopPropagation()}>
        <div className={styles.agreementHeader}>
          <span>{t("settings.243")}</span>
          <button className={styles.agreementClose} onClick={onClose}>
            <CloseOutlined />
          </button>
        </div>
        <div className={styles.agreementBody}>
          <pre className={styles.agreementText}>{agreementText}</pre>
        </div>
      </div>
    </div>
  );
};

const ConsentModal = ({ onAccept, onClose }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);

  return (
    <div className={styles.consentModalWrap}>
      {showAgreement && (
        <GdprAgreementPopup onClose={() => setShowAgreement(false)} />
      )}
      <div className={styles.consentIcon}>🌍</div>
      <h3 className={styles.consentTitle}>{t("settings.236")}</h3>
      <p className={styles.consentDesc}>{t("settings.237")}</p>
      <div className={styles.consentCheck}>
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        >
          {t("settings.238")}{" "}
          <button
            className={styles.consentLink}
            onClick={() => setShowAgreement(true)}
          >
            {t("settings.239")}
          </button>
          {t("settings.240")}
        </Checkbox>
      </div>
      <div className={styles.consentActions}>
        <button className={styles.consentCancel} onClick={onClose}>
          {t("settings.241")}
        </button>
        <button
          className={styles.consentContinue}
          disabled={!checked}
          onClick={() => checked && onAccept()}
        >
          {t("settings.242")}
        </button>
      </div>
    </div>
  );
};

const Representation = ({
  user,
  fullName,
  setFullName,
  phoneNumber,
  setPhoneNumber,
  setRole,
  roles,
  role,
  save,
  deleteLogo,
  numberRetrievedFromDB,
  setNumberRetrievedFromDB,
}) => {
  const userReducer = useSelector((state) => state.userReducer);
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isConsentOpen, setIsConsentOpen] = useState(false);
  const [deleteBtnClicked, setDeleteBtnClicked] = useState(false);
  const [verificationCode, setVerificationCode] = useState();
  const [smsSent, setSmsSent] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const TIMER = 120;
  const SHOW_PHONE_SMS = false;

  const updateTime = () => {
    setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
  };

  useEffect(() => {
    if (timeLeft > 0) updateTime();
  }, [timeLeft]);

  const handleAddNumber = () => {
    if (!isConsentOpen && !isPopupOpen) setIsConsentOpen(true);
  };

  const handleConsentAccepted = () => {
    setIsConsentOpen(false);
    setIsPopupOpen(true);
  };

  const handleDeleteNumber = () => {
    if (!deleteBtnClicked) setDeleteBtnClicked(true);
  };

  const handleConfirmDelete = async () => {
    setDeleteBtnClicked(false);
    const apiResponse = await apiRequest("users/deleteNumber", "POST", {
      phone: phoneNumber,
    });
    if (apiResponse?.success) {
      setPhoneNumber("");
      setNumberRetrievedFromDB(false);
      setSmsSent(false);
      notification.success({ message: "Successfully deleted number" });
    } else {
      notification.error({ message: "Failed to delete number" });
    }
  };

  const onClose = () => {
    if (isConsentOpen) setIsConsentOpen(false);
    else if (isPopupOpen) setIsPopupOpen(false);
    else if (deleteBtnClicked) setDeleteBtnClicked(false);
  };

  const sendSMS = async () => {
    try {
      setIsLoading(true);
      const apiResponse = await apiRequest("users/sendOTP", "POST", {
        phone: phoneNumber,
      });
      if (apiResponse?.success) {
        notification.success({ message: `OTP sent to ${phoneNumber} successfully.` });
        setSmsSent(true);
        setTimeLeft(TIMER);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        notification.error({ message: "Please verify your number" });
      }
    } catch (error) {
      notification.error({ message: "Failed to send OTP. Try again", error });
      setIsLoading(false);
    }
  };

  const resend = async () => {
    try {
      setIsLoading(true);
      const apiResponse = await apiRequest("users/sendOTP", "POST", {
        phone: phoneNumber,
      });
      if (apiResponse?.success) {
        notification.success({ message: `OTP sent to ${phoneNumber} successfully.` });
        setSmsSent(true);
        setTimeLeft(TIMER);
        setIsLoading(false);
      }
    } catch (error) {
      notification.error({ message: "Failed to send OTP. Try again", error });
      setIsLoading(false);
    }
  };

  const verifyOTP = async () => {
    try {
      setIsLoading(true);
      const apiResponse = await apiRequest("users/verifyOTP", "POST", {
        phone: phoneNumber,
        otp: verificationCode,
      });
      if (apiResponse?.success) {
        setIsPopupOpen(false);
        setIsLoading(false);
        setPhoneNumber(phoneNumber);
        setNumberRetrievedFromDB(true);
        notification.success({ message: "Mobile number registered successfully." });
      } else {
        setIsPopupOpen(false);
        setIsLoading(false);
        setPhoneNumber("");
        notification.error({ message: "Registration failed. Try again" });
      }
    } catch {
      notification.error({ message: "Invalid OTP" });
      setIsPopupOpen(false);
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <h2 className={styles.pageTitle}>{t("settings.1")}</h2>
      <p className={styles.pageSubtitle}>{t("settings.2")}</p>

      <div className={styles.card}>
        <h3 className={styles.cardTitle}>{t("settings.244")}</h3>

        {/* Full Name */}
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>{t("settings.3")}</label>
          <input
            className={styles.input}
            defaultValue={fullName}
            placeholder={t("settings.5")}
            onChange={(e) => setFullName(e.target.value)}
          />
        </div>

        {SHOW_PHONE_SMS && (
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>{t("settings.4")}</label>
            <p className={styles.fieldHint}>
              {t("settings.245")}
            </p>
            <div className={styles.phoneRow}>
              <input
                className={styles.input}
                value={phoneNumber || ""}
                placeholder={t("settings.248")}
                onChange={(e) => setPhoneNumber(e.target.value)}
                disabled={numberRetrievedFromDB}
              />
              {!numberRetrievedFromDB ? (
                <button className={styles.addBtn} onClick={handleAddNumber}>
                  <PlusOutlined /> {t("button.11")}
                </button>
              ) : (
                <button className={`${styles.addBtn} ${styles.deleteBtn}`} onClick={handleDeleteNumber}>
                  <DeleteOutlined /> {t("button.2")}
                </button>
              )}
            </div>
          </div>
        )}

        {/* Role */}
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>{t("settings.7")}</label>
          <p className={styles.fieldHint}>
            {t("settings.246")}
          </p>
          <Select
            className={styles.select}
            onChange={(value) => setRole(value)}
            value={role}
            placeholder={t("settings.8")}
            showSearch
            optionFilterProp="title"
          >
            {roles?.map((r) => (
              <Select.Option key={r} value={r} title={r}>
                {r}
              </Select.Option>
            ))}
          </Select>
        </div>

        {/* Branding */}
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>{t("settings.9")}</label>
          <p className={styles.fieldHint}>
            {t("settings.247")}
          </p>

          {!userReducer.logoUrl ? (
            <div className={styles.uploadArea}>
              <Uploader user={user} />
            </div>
          ) : (
            <div className={styles.logoPreview}>
              <img src={userReducer.logoUrl} alt="logo" className={styles.logoImg} />
              <button className={styles.removeLogoBtn} onClick={deleteLogo}>
                <DeleteOutlined /> {t("settings.191")}
              </button>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className={styles.actions}>
          <button className={styles.cancelBtnAction} onClick={() => {}}>
            {t("button.3")}
          </button>
          <button className={styles.saveAction} onClick={save}>
            {t("button.16")}
          </button>
        </div>
      </div>

      {/* Modals */}
      {SHOW_PHONE_SMS && isConsentOpen && (
        <Modal
          showModal={isConsentOpen}
          onClose={() => setIsConsentOpen(false)}
          showSaveButton={false}
          titleAsset=""
          footer={null}
        >
          <ConsentModal
            onAccept={handleConsentAccepted}
            onClose={() => setIsConsentOpen(false)}
          />
        </Modal>
      )}

      {SHOW_PHONE_SMS && isPopupOpen && (
        <Modal
          showModal={isPopupOpen}
          onClose={onClose}
          showSaveButton={false}
          titleAsset=""
          footer={null}
        >
          <AddPhnPopup
            setPhonenumber={setPhoneNumber}
            phonenumber={phoneNumber}
            smsSent={smsSent}
            timeLeft={timeLeft}
            verificationCode={verificationCode}
            setVerificationCode={setVerificationCode}
            isLoading={isLoading}
            sendSMS={sendSMS}
            resend={resend}
            verifyCode={verifyOTP}
          />
        </Modal>
      )}

      {SHOW_PHONE_SMS && deleteBtnClicked && (
        <Modal
          showModal={deleteBtnClicked}
          onClose={onClose}
          widthofmodal="450px"
          titleAsset=""
          onSave={handleConfirmDelete}
          showSaveButton={true}
          textonButton="delete"
        >
          <p>
            {t("settings.249")}
          </p>
        </Modal>
      )}
    </div>
  );
};

export default Representation;
